import { cloneDeep, pick } from 'lodash';
import request from '@/services/request';
import { GATEWAYS } from '@/utils';

// Included in the donation module so draft identity follows its existing reset lifecycle.
export default {
  state: {
    zelleInstructions: null,
    zelleRequestId: null,
    zelleRequestFingerprint: null,
    zelleDraftFingerprint: null
  },
  mutations: {
    SET_ZELLE_INSTRUCTIONS(state, value) {
      state.zelleInstructions = value;
    },
    SET_ZELLE_REQUEST_FINGERPRINT(state, value) {
      state.zelleRequestFingerprint = value;
    },
    SET_ZELLE_DRAFT_FINGERPRINT(state, value) {
      state.zelleDraftFingerprint = value;
    },
    SET_ZELLE_REQUEST_ID(state, value) {
      state.zelleRequestId = value;
    }
  },
  getters: {
    zelleDraftFingerprint(state) {
      return JSON.stringify(pick(state, ['amount', 'currency', 'frequency', 'campaignId', 'donationItems', 'donationItemsOtherAmount']));
    },
    zelleCheckoutFingerprint(state) {
      return JSON.stringify(
        pick(state, [
          'amount',
          'currency',
          'frequency',
          'campaignId',
          'donorDetails',
          'billingAddress',
          'customQuestions',
          'dedication',
          'designation',
          'anonymous',
          'comment',
          'fundraiserId',
          'solicitorId',
          'donationItems',
          'donationItemsOtherAmount'
        ])
      );
    }
  },
  actions: {
    async createZelleDonation({ state, rootState, getters, commit }, { draft = false } = {}) {
      const fingerprint = getters.zelleCheckoutFingerprint;
      const draftFingerprint = getters.zelleDraftFingerprint;
      if (!state.zelleRequestId) {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
        commit('SET_ZELLE_REQUEST_ID', `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`);
      }
      const donation = { ...cloneDeep(state), gateway: GATEWAYS.ZELLE, donationId: null, coverFeesAmount: 0, payCoverFees: false };
      const { data, error } = await request.post(`/public/donation/${rootState.orgId}/`, { donation, zelleDraft: draft });
      if (error) throw new Error(typeof data === 'string' ? data : data?.message || error.message || 'Unable to prepare Zelle instructions');
      if (state.zelleRequestId === donation.zelleRequestId) {
        commit('SET_ZELLE_INSTRUCTIONS', data);
        commit('SET_ZELLE_DRAFT_FINGERPRINT', draftFingerprint);
        commit('SET_ZELLE_REQUEST_FINGERPRINT', draft ? null : fingerprint);
      }
      return data;
    },
    async reportZelleSent({ state, rootState, commit }) {
      const requestId = state.zelleRequestId;
      const { data, error } = await request.post(`/public/zelle/${rootState.orgId}/${state.zelleInstructions.donationId}/sent`, {
        requestId
      });
      if (error) throw new Error(typeof data === 'string' ? data : data?.message || 'Unable to save payment update');
      if (state.zelleRequestId === requestId) commit('SET_ZELLE_INSTRUCTIONS', data);
      return data;
    }
  }
};
